export enum IntensityLevel {
    Low = 'low',
    Medium = 'medium',
    High = 'high',
    Top = 'top'
}
